import stickySummary from '../components/plan-summary/sticky'
import store from 'utils/store/withMiddleware'

function deleteExternalPlan(e) {
  store.update({ externalPlanSelected: undefined })
  e.stopPropagation()
  e.preventDefault()
  stickySummary()
}

export default deleteExternalPlan
